import { Container, interfaces } from 'inversify';

import { UnifiedRolesDomainContainer } from '../src/domains/UnifiedRoles/inversify.config';
import { UserDomainContainer } from '../src/domains/User/inversify.config';
import { TenantDomainContainer } from './domains/Tenant/inversify.config';
import { UserPrincipalDomainContainer } from './external/UserPrincipal/inversify.config';
import { SharedCoreDomainContainer } from './shared/core/inversify.config';

export const inversifyContainer: interfaces.Container = Container.merge(
  TenantDomainContainer.create(),
  UserDomainContainer.create(),
  SharedCoreDomainContainer.create(),
  UserPrincipalDomainContainer.create(),
  UnifiedRolesDomainContainer.create(),
);
